import React from "react";
import { Loading } from "../../App";
import Ajax, { domain } from "../ajax/Ajax";

class TopSales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      month: "",
      revTopSales: null,
      qtyTopSales: null,
    };
  }

  async fetchTopSalesData() {
    if (this.props.focus !== "ware") {
      let fetchResults = await Ajax.fetchData(
        `${domain}/en/api/shop/v1/top-sales/?focus_id=${this.props.focusObj.token}`
      );
      if (fetchResults) {
        if (fetchResults["status"] === 200) {
          this.setState({
            month: fetchResults.month,
            revTopSales: fetchResults.rev_top_sales,
            qtyTopSales: fetchResults.qty_top_sales,
          });
        }
      }
    }
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.focusObj.token !== prevProps.focusObj.token) {
      this.fetchTopSalesData();
    }
  }

  componentDidMount() {
    this.fetchTopSalesData();
  }

  render() {
    return (
      <div className="card is-shadowless bordered-card top-sales">
        <div className="card-header">
          <div className="card-header-title">
            TOP SALES
            <span className="ml-2"> - {this.state.month}</span>
          </div>
        </div>
        <div className="card-content">
          <h2 className="is-size-5 has-text-dark">Ranked By Revenue</h2>
          {this.state.revTopSales ? (
            <table className="table is-hoverable is-fullwidth">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Revenue</th>
                </tr>
              </thead>
              <tbody>
                {this.state.revTopSales.map((item, i) => (
                  <tr key={item.id + "-top-sale-rev" + i}>
                    <td>{i + 1}</td>
                    <td>{item.product}</td>
                    <td>{item.quantity}</td>
                    <td>
                      {item.currency} {item.revenue.toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>
              <Loading />
            </div>
          )}

          <hr />
          <h2 className="is-size-5 has-text-dark">Ranked By Quantity</h2>
          {this.state.qtyTopSales ? (
            <table className="table is-hoverable is-fullwidth">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Product</th>
                  <th>Qty</th>
                  <th>Revenue</th>
                </tr>
              </thead>
              <tbody>
                {this.state.qtyTopSales.map((item, i) => (
                  <tr key={item.id + "-top-sale-qty" + i}>
                    <td>{i + 1}</td>
                    <td>{item.product}</td>
                    <td>{item.quantity}</td>
                    <td>
                      {item.currency} {item.revenue.toLocaleString()}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <div>
              <Loading />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default TopSales;
